module.exports = __webpack_public_path__ + "img/sld_scb_10_t1_green.f9d94410.svg";